(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ae-bday-tiles"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var KEY = 'ae_bday_mode';
      function apply(mode) {
        document.documentElement.setAttribute('data-ae-bday-mode', mode);
        document.querySelectorAll('[data-ae-bday-set]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-ae-bday-set') === mode ? 'true' : 'false');
        });
      }
      var start = 'abo';
      try { start = sessionStorage.getItem(KEY) || 'abo'; } catch (e) {}
      document.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-ae-bday-set]');
        if (!b) return;
        var mode = b.getAttribute('data-ae-bday-set');
        apply(mode);
        try { sessionStorage.setItem(KEY, mode); } catch (e2) {}
      });
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { apply(start); });
      } else { apply(start); }
      document.addEventListener('shopify:section:load', function () { apply(document.documentElement.getAttribute('data-ae-bday-mode') || start); });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
